import { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { History } from 'lucide-react';
import ChefHeader from '../shared/ui/ChefHeader';
import { SegmentedPicker, SearchBar, LoadingView, EmptyState } from '../shared/ui';
import { useAuth } from '../contexts/AuthContext';
import { useDeliveredOrders, historyRangeStart } from '../components/earnings/useDeliveredOrders';
import DeliveryHistoryCard from '../components/history/DeliveryHistoryCard';

const FILTERS = ['Day', 'Week', 'Month', 'Year'];

// Mirrors iOS DeliveryHistoryView: rolling time filter + search over the
// driver's delivered/completed orders from the main orders collection.
export default function HistoryPage() {
  const { driverId } = useAuth();
  const navigate = useNavigate();
  const { orders, loading } = useDeliveredOrders(driverId);
  const [filter, setFilter] = useState('Week'); // iOS default
  const [search, setSearch] = useState('');

  const filtered = useMemo(() => {
    const start = historyRangeStart(filter);
    const now = new Date();
    let list = orders.filter(o => o.date >= start && o.date <= now);
    const s = search.trim().toLowerCase();
    if (s) {
      list = list.filter(o =>
        (o.id || '').toLowerCase().includes(s) ||
        (o.orderNumber || '').toLowerCase().includes(s) ||
        (o.customerName || '').toLowerCase().includes(s) ||
        (o.restaurantName || '').toLowerCase().includes(s));
    }
    return list;
  }, [orders, filter, search]);

  return (
    <div>
      <ChefHeader title="History" />
      <div className="px-4 pt-3 space-y-3">
        <SegmentedPicker options={FILTERS} value={filter} onChange={setFilter} />
        <SearchBar
          value={search}
          onChange={setSearch}
          placeholder="Search deliveries..."
        />

        {loading ? (
          <LoadingView label="Loading deliveries..." />
        ) : filtered.length === 0 ? (
          <EmptyState
            icon={History}
            title="No deliveries found"
            subtitle="No deliveries found for this period"
          />
        ) : (
          <div className="space-y-2 pb-4">
            {filtered.map(o => (
              <button
                key={o.id}
                onClick={() => navigate(`/driver/history/${o.id}`)}
                className="w-full"
              >
                <DeliveryHistoryCard order={o} />
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
